import React, { Component } from 'react';
import './Input.scss';

interface IInput {
  [key: string]: any,
  
  id: string,
  /**
   * optional icon to be placed before the actual text
   */
  icon?: string,
  /**
   * show the error state
   */
  isError?: boolean,
  /**
   * show error message
   */
  errorMsg?: string,
  /**
   * type of error icon
   */
  errorIcon?: string,
  /**
   * callback for error icon
   */
  errorCb?: () => {},
  /**
   * classes
   */
  className?: string,
  /**
   * placeholder
   */
  placeholder?: string,
  /**
   * on change hook
   */
  onChange?: (evt: any) => any,
  /**
   * value
   */
  value?: string | number,
  type?: string,
  /**
   * display error with a warning layout
   */
  warninglayout?: boolean,
  required?: boolean,
  autocomplete?: string | boolean,
  pattern?: string
}

class Input extends Component<IInput, any> {
  render() {
    const {
      icon = "",
      isError = false,
      errorMsg = "",
      errorIcon = "exclamation-circle",
      errorCb = () => { },
      warninglayout = false,
      className = "",
      value = "",
      ...rest
    } = this.props;

    return (
      <div className={isError ? (`cc-input cc-input${warninglayout ? '--warning' : '--error'} ${className}`) : `cc-input ${className}`}>
        {icon && <i className={`cc-input__icon ${icon}`} />}
        <input
          type="text"
          className={icon ? "cc-input__field cc-input__field--icon" : "cc-input__field"}
          value={value}
          //spread all the other props
          {...rest}
        />
        {isError &&
          <span className={`cc-input__error-container ${warninglayout ? 'cc-input__error-container--warning' : ''}`}>
            <i role="button" onClick={errorCb} className={`cc-input__error-icon ${warninglayout ? 'far fa-info-circle' : errorIcon}`} tabIndex={-1} />
            <span className="cc-input__error-msg">{errorMsg}</span>
          </span>
        }
      </div>
    );
  }
}

export default Input;
